export const fromLongToShort = {
  en_US: 'en',
  hu_HU: 'hu',
  es_ES: 'es',
  de_DE: 'de',
  fr_FR: 'fr'
};

export const fromShortToLong = {
  en: 'en_US',
  hu: 'hu_HU',
  es: 'es_ES',
  fr: 'fr_FR',
  de: 'de_DE'
};

export const availableLanguages = [
  'en_US',
  'hu_HU',
  'fr_FR',
  'es_ES',
  'de_DE'
];



// WEBPACK FOOTER //
// ./src/lang/languageCodes.js